// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_inputContainer__XbU9t {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.styles_inputLabel__\\+5jo8 {
  font: var(--typography-body-m-medium);
  color: var(--color-black);
  margin-bottom: 4px;
}

.styles_inputWrapper__wRbK8 {
  position: relative;
  width: 100%;
}

.styles_customInput__brZxn {
  width: 100%;
  padding: 10px 14px;
  font-size: 16px;
  border: 1px solid var(--color-gray-strokes);
  border-radius: 12px;
  color: var(--color-black);
  background-color: var(--color-white);
  transition: all 0.2s ease;
  outline: none;
}
@media (min-width: 768px) {
  .styles_customInput__brZxn {
    padding: 12px 16px;
    font: var(--typography-body-m-regular);
  }
}
.styles_customInput__brZxn::placeholder {
  color: var(--color-text-secondary);
  font: var(--typography-body-m-regular);
}
.styles_customInput__brZxn:focus, .styles_customInput--focused__cVE2p {
  border-color: var(--color-blue-light);
}
.styles_customInput--error__9b4sH {
  border-color: var(--color-error);
  box-shadow: 0 0 0 1px var(--color-error);
}
.styles_customInput--error__9b4sH:focus {
  border-color: var(--color-error);
  box-shadow: 0 0 0 1px var(--color-error);
}
.styles_customInput--error__9b4sH:hover {
  border-color: var(--color-error);
}
.styles_customInput--disabled__J5nde {
  background-color: var(--color-button-disabled);
  border-color: var(--color-button-disabled);
  color: var(--color-text-secondary);
  cursor: not-allowed;
}
.styles_customInput--disabled__J5nde::placeholder {
  color: var(--color-text-secondary);
}
.styles_customInput--filled__90FKi {
  background-color: var(--color-white);
  color: var(--color-black);
}
.styles_customInput--small__MJMWw {
  padding: 8px 12px;
  font: var(--typography-body-s-medium);
}
.styles_customInput--large__kEES9 {
  padding: 16px 20px;
  font: var(--typography-body-m-medium);
}
.styles_customInput__brZxn:hover:not(:disabled):not(.styles_customInput--disabled__J5nde), .styles_customInput__brZxn:active:not(:disabled):not(.styles_customInput--disabled__J5nde) {
  border-color: var(--color-blue-light);
}

.styles_supportiveText__LBPCS {
  font: var(--typography-body-s-medium);
  color: var(--color-text-secondary);
  margin-top: 4px;
  min-height: 16px;
}
.styles_supportiveText--error__6rlpY {
  color: var(--color-error);
}`, "",{"version":3,"sources":["webpack://./src/components/input/styles.module.scss","webpack://./src/styles/mixins.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;AAAF;;AAGA;EACE,qCAAA;EACA,yBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,WAAA;AAAF;;AAGA;EACE,WAAA;EACA,kBAAA;EACA,eAAA;EACA,2CAAA;EACA,mBAAA;EACA,yBAAA;EACA,oCAAA;EACA,yBAAA;EACA,aAAA;AAAF;ACrBE;EDYF;IAYI,kBAAA;IACA,sCAAA;EACF;AACF;AACE;EACE,kCAAA;EACA,sCAAA;AACJ;AAEE;EAEE,qCAAA;AADJ;AAIE;EACE,gCAAA;EACA,wCAAA;AAFJ;AAII;EACE,gCAAA;EACA,wCAAA;AAFN;AAKI;EACE,gCAAA;AAHN;AAOE;EACE,8CAAA;EACA,0CAAA;EACA,kCAAA;EACA,mBAAA;AALJ;AAOI;EACE,kCAAA;AALN;AASE;EACE,oCAAA;EACA,yBAAA;AAPJ;AAUE;EACE,iBAAA;EACA,qCAAA;AARJ;AAWE;EACE,kBAAA;EACA,qCAAA;AATJ;AAYE;EAEE,qCAAA;AAXJ;;AAeA;EACE,qCAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;AAZF;AAcE;EACE,yBAAA;AAZJ","sourcesContent":["@import \"mixins\";\n.inputContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.inputLabel {\n  font: var(--typography-body-m-medium);\n  color: var(--color-black);\n  margin-bottom: 4px;\n}\n\n.inputWrapper {\n  position: relative;\n  width: 100%;\n}\n\n.customInput {\n  width: 100%;\n  padding: 10px 14px;\n  font-size: 16px;\n  border: 1px solid var(--color-gray-strokes);\n  border-radius: 12px;\n  color: var(--color-black);\n  background-color: var(--color-white);\n  transition: all 0.2s ease;\n  outline: none;\n\n  @include md {\n    padding: 12px 16px;\n    font: var(--typography-body-m-regular);\n  }\n\n  &::placeholder {\n    color: var(--color-text-secondary);\n    font: var(--typography-body-m-regular);\n  }\n\n  &:focus,\n  &--focused {\n    border-color: var(--color-blue-light);\n  }\n\n  &--error {\n    border-color: var(--color-error);\n    box-shadow: 0 0 0 1px var(--color-error);\n\n    &:focus {\n      border-color: var(--color-error);\n      box-shadow: 0 0 0 1px var(--color-error);\n    }\n\n    &:hover {\n      border-color: var(--color-error);\n    }\n  }\n\n  &--disabled {\n    background-color: var(--color-button-disabled);\n    border-color: var(--color-button-disabled);\n    color: var(--color-text-secondary);\n    cursor: not-allowed;\n\n    &::placeholder {\n      color: var(--color-text-secondary);\n    }\n  }\n\n  &--filled {\n    background-color: var(--color-white);\n    color: var(--color-black);\n  }\n\n  &--small {\n    padding: 8px 12px;\n    font: var(--typography-body-s-medium);\n  }\n\n  &--large {\n    padding: 16px 20px;\n    font: var(--typography-body-m-medium);\n  }\n\n  &:hover:not(:disabled):not(.customInput--disabled),\n  &:active:not(:disabled):not(.customInput--disabled) {\n    border-color: var(--color-blue-light);\n  }\n}\n\n.supportiveText {\n  font: var(--typography-body-s-medium);\n  color: var(--color-text-secondary);\n  margin-top: 4px;\n  min-height: 16px;\n\n  &--error {\n    color: var(--color-error);\n  }\n}\n","@mixin sm {\n  @media (min-width: 640px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (min-width: 768px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (min-width: 1024px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (min-width: 1280px) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputContainer": `styles_inputContainer__XbU9t`,
	"inputLabel": `styles_inputLabel__+5jo8`,
	"inputWrapper": `styles_inputWrapper__wRbK8`,
	"customInput": `styles_customInput__brZxn`,
	"customInput--focused": `styles_customInput--focused__cVE2p`,
	"customInput--error": `styles_customInput--error__9b4sH`,
	"customInput--disabled": `styles_customInput--disabled__J5nde`,
	"customInput--filled": `styles_customInput--filled__90FKi`,
	"customInput--small": `styles_customInput--small__MJMWw`,
	"customInput--large": `styles_customInput--large__kEES9`,
	"supportiveText": `styles_supportiveText__LBPCS`,
	"supportiveText--error": `styles_supportiveText--error__6rlpY`
};
export default ___CSS_LOADER_EXPORT___;
